import axiosInterceptor from '../../../../../services/axiosInterceptor';
import { baseUrl } from '../../../../../configs/constants';

export const deleteExemptPlans = (ids) => {
  return axiosInterceptor.delete(baseUrl + '/exempt-plans/' + ids);
};
